import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import "./Toast.css";

const Toast = (props) => {
  const { toastList, position, autoDelete, dismissTime } = props;
  const [list, setList] = useState(toastList);

  useEffect(() => {
    setList([...toastList]);

    // eslint-disable-next-line
  }, [toastList]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id);
      }
    }, dismissTime);

    return () => {
      clearInterval(interval);
    };

    // eslint-disable-next-line
  }, [toastList, autoDelete, dismissTime, list]);

  const deleteToast = (id) => {
    const listItemIndex = list.findIndex((e) => e.id === id);
    const toastListItem = toastList.findIndex((e) => e.id === id);
    list.splice(listItemIndex, 1);
    toastList.splice(toastListItem, 1);
    setList([...list]);
  };

  return (
    <div className={`notification-main`}>
      <div className={`notification-container ${position}`}>
        {list.map((toast, i) => (
          <div className={`rpn-notification-card ${toast.theme}`}>
            <div className={`rpn-notification-card-top ${toast.theme}`}>
              <span>{toast.title}</span>
              <span
                className={`rpn-notification-card-close ${toast.theme}`}
                onClick={() => {
                  deleteToast(toast.id);
                }}
              >
                {toast.closeButton || "close"}
              </span>
            </div>
            <div
              className={`rpn-notification-card-bottom ${toast.theme}`}
              style={{cursor: "pointer"}}
              onClick={() => {
                deleteToast(toast.id);
                toast.onClick();
              }}
            >
              {/* <span className="subtitle">{toast.subtitle}</span> */}
              <span className="message">{toast.description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Toast.propTypes = {
  toastList: PropTypes.array.isRequired,
  position: PropTypes.string,
  autoDelete: PropTypes.bool,
  dismissTime: PropTypes.number,
};

export default Toast;
